import React from 'react';
import { MuiFormBuilder } from 'components';

import uiSchema from './uiSchema';
import schema from './schema';
import { useSelector } from 'react-redux';
import { hasRequiredRole } from 'helpers';

const Form = ({ init, setFilter }) => {
  const formData = { ...init };

  const onChange = async ({ formData }) => {
    setFilter(formData);
  };

  const { vehicleTypes } = useSelector((state) => state.models);
  const { vehicleStatuses } = useSelector((state) => state.models);
  const { userInfo } = useSelector((state) => state.auth);
  
  const isSuperAdmin = hasRequiredRole(['superadmin'], userInfo?.roles);

  return (
    <MuiFormBuilder
      showSubmit={false}
      formContext={{ clearable: true }}
      schema={schema(vehicleTypes, vehicleStatuses, isSuperAdmin)}
      uiSchema={uiSchema(isSuperAdmin)}
      formData={formData}
      onChange={onChange}
    />
  );
};

export default Form;
